import I18n from 'I18n';
export function secondsToFormattedTime(seconds) {
  const momentPlaybackTime = I18n.moment(0).hours(0).minutes(0).second(seconds);
  if (!momentPlaybackTime) return null;
  return momentPlaybackTime.hours() > 0 ? momentPlaybackTime.format('H:mm:ss') : momentPlaybackTime.format('m:ss');
}
export const formatSecondsToDescriptiveTimeFormat = value => {
  if (!value) {
    return null;
  }
  const isNegative = value < 0;
  const absoluteValue = Math.round(Math.abs(value) * 10) / 10; // Round to the nearest tenth

  let formattedValue;
  if (absoluteValue < 60) {
    formattedValue = absoluteValue < 1 ? `${absoluteValue.toFixed(1)} ${I18n.text('objectCommentsThread.callStats.units.time')}` : I18n.moment(0).hours(0).minutes(0).second(absoluteValue).format('s [seconds]');
  } else {
    const minutes = Math.floor(absoluteValue / 60);
    const seconds = Math.round(absoluteValue % 60); // This ensures seconds are rounded properly for display
    const momentValue = I18n.moment(0).hours(0).minutes(minutes).second(seconds);
    formattedValue = momentValue.format('m [min] ss [seconds]');
  }

  // Add negative sign if the original value was negative and value is not 0
  return isNegative && absoluteValue !== 0 ? `-${formattedValue}` : formattedValue;
};
export function formattedTimeToSeconds(formattedTime) {
  const timeParts = formattedTime.split(':');
  if (timeParts.length === 1) {
    return I18n.moment.duration(`00:00:${formattedTime}`).asSeconds();
  } else if (timeParts.length === 2) {
    return I18n.moment.duration(`00:${formattedTime}`).asSeconds();
  }
  return I18n.moment.duration(formattedTime).asSeconds();
}

// Returns how long ago something was
export function formatTimeAgo(timestamp) {
  return I18n.moment.duration(I18n.moment(timestamp).diff(I18n.moment())).humanize();
}
export function formatMonthDayYearAtTimeString(timestamp) {
  return I18n.moment.userTz(timestamp).format('lll z');
}

// Checks to see if the string only contains numbers and colon (:) symbol
export function isValidTimeChars(time) {
  const regex = /^[0-9:]*$/g;
  return regex.test(time);
}